import config from '@/config'

// Trusted device enrolment stores the device key pair in IndexedDB and
// generates it via WebCrypto — without both, enrolment cannot work.
const isDeviceKeyStorageSupported = (): boolean => {
  return typeof indexedDB !== 'undefined' && typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined'
}

const isEnabledForUser = (email?: string): boolean => {

  if (config.TRUSTED_DEVICE_ENROLLMENT_ENABLED === 'true') {
    return true
  }

  if (config.TRUSTED_DEVICE_ENROLLMENT_WHITELISTED_USERS) {
    const whitelistedUsers = config.TRUSTED_DEVICE_ENROLLMENT_WHITELISTED_USERS.split(',').map(e => e.trim())
    return email ? whitelistedUsers.includes(email) : false
  }

  return false

}

// TRUSTED_DEVICE_ENROLLMENT_PARTNERS is a comma-separated allowlist of Partner
// codes (e.g. 'siteminder,littlehotelier'). An empty string allows every
// partner; a single partner code restricts enrolment to that partner only.
const isPartnerAllowed = (partnerCode?: string): boolean => {

  if (!config.TRUSTED_DEVICE_ENROLLMENT_PARTNERS) {
    return true
  }

  const allowedPartners = config.TRUSTED_DEVICE_ENROLLMENT_PARTNERS.split(',').map(p => p.trim())
  return partnerCode ? allowedPartners.includes(partnerCode) : false

}

export const isTrustedDeviceEnrollmentEnabled = (email?: string, partnerCode?: string): boolean => {

  if (!isDeviceKeyStorageSupported()) {
    return false
  }

  return isEnabledForUser(email) && isPartnerAllowed(partnerCode)

}
